import { getCurrentInstance } from 'vue'

type Headful<T> = (props: T) => void

const useHeadful = <T extends object>(): Headful<T> => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return getCurrentInstance()!.proxy.$headful
}

export {
    useHeadful
}
